export default __webpack_public_path__ + "static/media/marc-andre.b3c5e77e.jpg";